import { CurrencyPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'currencyExtended',
  standalone: false,
})
export class CurrencyExtendedPipe extends CurrencyPipe
  implements PipeTransform {
  public transform(
    value: any,
    currencyCode?: string,
    display?: 'code' | 'symbol' | 'symbol-narrow' | string | boolean,
    digitsInfo?: string,
    locale?: string
  ) {
    let valueSplitter = [];
    let dec;
    let result;

    if (value % 1 !== 0) {
      valueSplitter = value.toString().split('.');
    }

    result = super.transform(value, currencyCode, display, digitsInfo, locale);

    if (valueSplitter.length > 1) {
      if (valueSplitter[1].length === 1) {
        dec = valueSplitter[1] + '0';
      } else {
        dec = valueSplitter[1];
      }
      result = `${result.split('.')[0]}.${dec}`;
    }

    return result;
  }
}
